// Resources/Private/JavaScript/Controllers/HeaderController.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["menuToggle", "dropdownToggle", "dropdown"];

    toggleMenu(event) {
        event.preventDefault();

        const isOpen = this.menuToggleTarget.getAttribute("aria-expanded") === "true";
        this.setMenuOpen(!isOpen);
    }

    toggleDropdown(event) {
        event.preventDefault();

        const trigger = event.currentTarget;
        const dropdown = this.dropdownFor(trigger);

        if (!dropdown) {
            return;
        }

        const isOpen = trigger.getAttribute("aria-expanded") === "true";
        this.closeDropdowns(trigger);
        this.setDropdownOpen(trigger, dropdown, !isOpen);
    }

    closeDropdownOnFocusOut(event) {
        if (event.currentTarget.contains(event.relatedTarget)) {
            return;
        }

        const trigger = event.currentTarget.querySelector("[data-header-target='dropdownToggle']");
        const dropdown = trigger ? this.dropdownFor(trigger) : null;

        if (trigger && dropdown) {
            this.setDropdownOpen(trigger, dropdown, false);
        }
    }

    closeFromOutside(event) {
        if (this.element.contains(event.target)) {
            return;
        }

        this.closeDropdowns();
        this.setMenuOpen(false);
    }

    closeOnEscape(event) {
        if (event.key !== "Escape") {
            return;
        }

        const openDropdownTrigger = this.dropdownToggleTargets.find(
            (trigger) => trigger.getAttribute("aria-expanded") === "true",
        );

        if (openDropdownTrigger) {
            event.preventDefault();
            this.closeDropdowns();
            openDropdownTrigger.focus();
            return;
        }

        if (this.menuToggleTarget.getAttribute("aria-expanded") === "true") {
            event.preventDefault();
            this.setMenuOpen(false);
            this.menuToggleTarget.focus();
        }
    }

    setMenuOpen(isOpen) {
        this.menuToggleTarget.setAttribute("aria-expanded", String(isOpen));
        this.menuToggleTarget.setAttribute(
            "aria-label",
            isOpen ? "Hauptnavigation schließen" : "Hauptnavigation öffnen",
        );

        if (!isOpen) {
            this.closeDropdowns();
        }
    }

    closeDropdowns(exceptTrigger = null) {
        this.dropdownToggleTargets.forEach((trigger) => {
            if (trigger === exceptTrigger) {
                return;
            }

            const dropdown = this.dropdownFor(trigger);
            if (dropdown) {
                this.setDropdownOpen(trigger, dropdown, false);
            }
        });
    }

    setDropdownOpen(trigger, dropdown, isOpen) {
        trigger.setAttribute("aria-expanded", String(isOpen));
        trigger.setAttribute("aria-label", `Untermenü ${trigger.dataset.label} ${isOpen ? "schließen" : "öffnen"}`);
        dropdown.hidden = !isOpen;
    }

    dropdownFor(trigger) {
        const dropdownId = trigger.getAttribute("aria-controls");
        return this.dropdownTargets.find((dropdown) => dropdown.id === dropdownId);
    }
}
